module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Histórico de logs de importações")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.historicoLogs.length) ? _c('div', {
    staticClass: "text-dark resultado-success m-t-xl"
  }, [_c('i', {
    staticClass: "fa fa-warning fa-5x"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.TiposRelatorioPreparacaoLeilao.FUNCOES_TIPOS_RELATORIO[_vm.tipoLog].messageEmpty))])]) : _c('div', {
    staticClass: "informacoes-historico m-b-lg"
  }, [_c('div', [_vm._v("Foram encontrados "), _c('span', [_vm._v(_vm._s(_vm.historicoLogs.length))]), _vm._v(" log" + _vm._s(_vm.historicoLogs.length !== 1 ? 's' : '') + " para este leilão")])]), _vm._v(" "), (_vm.historicoLogs.length) ? _c('div', [_c('table', {
    staticClass: "table-lotes-leilao table table-clicked table-striped bg-whit b-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("Data da Importação")]), _vm._v(" "), _c('th', {
    staticClass: "text-nowrap text-center"
  }, [_vm._v("Opções")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.historicoLogs), function(log) {
    return _c('tr', {
      staticClass: "leilao-list-lote-item"
    }, [_c('td', [_vm._v(_vm._s(_vm._f("formatarData")(log.data.date)))]), _vm._v(" "), _c('td', [_c('u-button', {
      staticClass: "btn btn-info btn-xs",
      on: {
        "click": function($event) {
          return _vm.selecionaLog(log)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" Ver detalhes")])], 1)])
  }), 0)])]) : _vm._e()])])]), _vm._v(" "), (_vm.showViewer) ? _c('popup-viewer', {
    attrs: {
      "title": "Histórico de logs de importação"
    },
    on: {
      "close": _vm.closeViewer
    }
  }, [(_vm.tipoLog === _vm.TiposRelatorioPreparacaoLeilao.TIPO_RELATORIO_CSV_GRV) ? _c('ResultadoImportacaoCsvGrv', {
    attrs: {
      "relatorio": _vm.logSelecionado
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tipoLog === _vm.TiposRelatorioPreparacaoLeilao.TIPO_RELATORIO_IMPORTACAO_SECUNDARIA) ? _c('ResultadoImportacaoSecundariaLeilao', {
    attrs: {
      "relatorio": _vm.logSelecionado
    }
  }) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2de485cd","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/leiloes/components/HistoricoLogsImportacaoPreparacaoLeilao.vue
// module id = 2002
// module chunks = 6